import extDisabled from 'extDisabled';
import React from 'react';
import { Table, Icon } from 'antd';
import serviceFeeFormat from 'serviceFeeFormat';
import styles from './style.scss?__local'
import imgExt from 'assets/img/ext_default.png';
import * as R from 'ramda'
// import Swiper from 'react-id-swiper'
// import 'swiper/css/swiper.css'

let data = {};

const handlers = {
  extName(name) {
    return name + (extDisabled(data) ? '(已下架)' : '')
  },

  /*
 *   extMarketSnapshots (snapshots) {
 *     let list = snapshots && snapshots.length ? snapshots : []
 *     let count = list.length
 *
 *     return (
 *       <div className={styles['images']} style={{width: (375*0.8+10)*count + 'px'}}>
 *         {
 *           list.map((url, i) => {
 *             return url ? (
 *               <div className={styles['img']} key={i}>
 *                 <img src={url} />
 *               </div>
 *             ) : null
 *           })
 *         }
 *       </div>
 *     )
 *   },
 */

  extMarketSnapshots(snapshots) {
    const list = R.defaultTo([], snapshots)
    // const list = R.take(2, snapshots)
    return (
      <>
        {
          list.map((url, idx) => (url ? (
            <img className={styles['media-item']} src={url} key={idx} />
          ) : null))
        }
      </>
    )
  },

  extMarketVideoList(videoList) {
    const list = R.defaultTo([], videoList)
    // const list = []
    /*
     * const list = [
     *   'http://172.21.112.225:8080/s8.mp4',
     * ]
     */
    return list.map((url, idx) => (url
      ? (
        <video controls disablePictureInPicture controlsList="nodownload" className={styles['media-item']} key={idx}>
          <source src={url} type="video/mp4" />
          <span>对不起, 您的浏览器不支持播放 MP4</span>
        </video>
      )
      : null))
  },

  extVersionTerms(url) {
    return url ? <a target="_blank" href={url}>{url}</a> : null
  },

  extVersionPrivacy(url) {
    return url ? <a target="_blank" href={url}>{url}</a> : null
  },

  extLogo(src) {
    return src ? (src + '?x-oss-process=image/resize,limit_0,m_fill,w_150,h_150/sharpen,80/format,png/interlace,1/quality,q_90/rounded-corners,r_75') : imgExt
  },
  serviceFee(data) {
    const list = data.serviceFee;
    const typeList = data.types;

    const currentTypeItem = typeList.find(item => item.type == data.type) || {};
    const currentType = currentTypeItem.type;

    const isUseGiftFeeType = currentType == 2;

    const { unit } = typeList.find(item => item.type == data.type) || {}
    const serviceFeeMin = Math.min.apply(null, list.map(item => item.min));

    const formatList = list.map((item, idx) => ({
      conditionDesc: serviceFeeFormat.condition(currentType, item.min, item.max),
      feeDesc: serviceFeeFormat.fee(currentType, item.fee),
      key: idx,
    }))

    formatList.unshift({
      conditionDesc: serviceFeeFormat.getFreeConditionText(currentType, serviceFeeMin),
      feeDesc: '免费',
      key: '-1',
    })

    if (isUseGiftFeeType) {
      formatList.push({
        conditionDesc: '封顶费用',
        feeDesc: currentTypeItem.maxServiceFee,
        key: formatList.length + 1,
      })
    }

    const columns = [
      [serviceFeeFormat.getTableHeadText(currentType, unit), 'conditionDesc'],
      [`本月收取（虎牙币）`, 'feeDesc'],
    ].map((item, idx) => ({
      title: item[0],
      dataIndex: item[1],
      key: item[1],
      render: (text, record) => {
        if (idx == 1 && record.key == '-1') {
          return <span className = {styles.free_text}>{text}</span>
        } else {
          return <span>{text}</span>;
        }
      },
    }))

    return (
      <Table columns={columns} dataSource={formatList}  size="small" pagination={false}/>
    )
  },

}

const adtper = cfg => {
  data = cfg;

  return handlers;
}

export default adtper;
